import { useMemo, useCallback } from "react"
import { Grid, Typography } from "@mui/material"

import {
    IContractDetailsProps,
    IDisplayDataItem,
} from "src/views/contracts/pages/details/types/contract-detail"
import { formatDateTime } from "src/lib/date"

import { StyledContractDetails } from "src/views/contracts/pages/details/styled"

export const ContractDetails = ({
    title,
    dataList,
    data,
}: IContractDetailsProps) => {
    const formatValue = useCallback(
        (value: IDisplayDataItem["value"], key?: string) => {
            if (value instanceof Date) {
                return formatDateTime(value)
            }

            if (key === "annual_rent" || key === "monthly_rent") {
                return `${value} kr`
            }

            return value
        },
        [],
    )

    const displayData = useMemo(() => {
        if (data == null) {
            return dataList.map(
                ({ label }) =>
                    ({
                        label,
                        value: "-",
                    } as IDisplayDataItem),
            )
        }

        return dataList.map(({ label, key }) => {
            const value =
                typeof key === "string"
                    ? data[key as keyof typeof data]
                    : undefined

            return {
                label,
                value: value ?? "-",
                isStatus: key === "status",
                key,
            } as IDisplayDataItem
        })
    }, [data, dataList])

    return (
        <StyledContractDetails.SectionWrapper>
            <StyledContractDetails.SectionTitle>
                {title}
            </StyledContractDetails.SectionTitle>
            <StyledContractDetails.GridContainer container spacing={2}>
                {displayData.map((item, index) => (
                    <Grid item xs={12} sm={12} key={index}>
                        <StyledContractDetails.DetailRow>
                            <Typography
                                variant="subtitle2"
                                sx={{ width: "40%" }}
                            >
                                {item.label}
                            </Typography>
                            <StyledContractDetails.FieldValue>
                                {formatValue(item.value, item.key)}
                            </StyledContractDetails.FieldValue>
                        </StyledContractDetails.DetailRow>
                    </Grid>
                ))}
            </StyledContractDetails.GridContainer>
        </StyledContractDetails.SectionWrapper>
    )
}
